import React from 'react';
import Header from '@/components/PeriodSummary/Header';

function PeriodSummary({ children, period }) {
  return (
    <>
      <Header period={period} />
      { children }
    </>
  )
}

export default PeriodSummary;
